export default {
  showActiveAlarmsOnly: 'Pokaż tylko aktywne alarmy',
};
